var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';

import { showByType } from "../../Metadata/components/Metadata";


















const formatProperty = (prop) => {
  if (!(prop !== null && prop !== void 0 && prop.value)) {
    return undefined;
  }

  const inheritedMedia =
  prop.type === 'inherit' && (prop.inheritedType === 'image' || prop.inheritedType === 'media');
  const typeMedia = prop.type === 'image' || prop.type === 'media';

  if (inheritedMedia || typeMedia) {
    return undefined;
  }
  return showByType({ prop, compact: true });
};

export const TableCellComponent = (props) => {
  const cellValue = formatProperty(props.content);
  return /*#__PURE__*/(
    _jsx("div", { className: `table-view-cell table-view-row-zoom-${props.zoomLevel}` }, void 0, cellValue));

};

export const TableCell = /*#__PURE__*/React.memo(TableCellComponent);